/*
 * Copyright (c) 2024-2025 Nodals AI Ltd
 * All rights reserved.
 */

import type { PropertyConfig, SiteEnabledFeature } from '../types/index';

class SiteConfig {
  private static _instance: SiteConfig | null = null;
  private _info: PropertyConfig;

  private constructor(info: PropertyConfig) {
    this._info = info;
  }

  public static getInstance(info?: PropertyConfig): SiteConfig {
    if (!SiteConfig._instance) {
      if (!info) {
        throw new Error('SiteConfig must be initialised with Property configuration');
      }
      SiteConfig._instance = new SiteConfig(info);
    }
    return SiteConfig._instance;
  }

  public get id(): string {
    return this._info.id;
  }

  public get nodalsAdvertiserId(): string {
    return this._info.advid || '';
  }

  public get directLearningAdvertiserIgnoreList(): string[] {
    return this._info.dlail || [];
  }

  public hasFeatureEnabled(feature: SiteEnabledFeature): boolean {
    return Boolean(this._info[feature]);
  }
}

export { SiteConfig };
